
import {
  defineComponent, onBeforeMount, reactive,
} from 'vue';
import { Modal } from 'ant-design-vue';
import storeSistema from '@/store/storeSistema';
import { useTelaBase } from '@/core/composables/TelaBase';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import ColunaGrade from '@/core/components/Tela/ColunaGrade.vue';
import Paginacao from '@/core/components/Tela/Paginacao.vue';
import Icone from '@/core/components/Icone.vue';
import Card from '@/core/components/Tela/Card.vue';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import BuscaGeral from '@/core/components/BuscaAvancada/BuscaGeral.vue';
import PreferenciasColuna from '@/core/components/Preferencias/ColunaTabela.vue';
import CfopModal from './CfopModal.vue';
import { EStatusRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { ECustomRenderRow, IColumn } from '@/core/models/AntDesign/IColumn';
import { IParametrosConsulta } from '@/core/models/Consulta/IParametrosConsulta';
import { ETipoPermissao } from '@/models/Enumeradores/MeuSistema/Usuarios/ETipoPermissao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import { EVinculoEmpresa } from '@/core/models/Enumeradores/EEVinculoEmpresa';
import { useGradeBase } from '@/core/composables/GradeBase';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { useCrudBase } from '@/core/composables/CrudBase';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import ServicoCfop from '@/servicos/Cadastros/Tributacoes/ServicoCfop';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { ETipoAmbiente } from '@/models/Enumeradores/PainelAdministrativo/ETipoAmbiente';
import { ICfop } from '@/models/Entidades/Cadastros/Tributacoes/ICfop';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';

export default defineComponent({
  name: 'CfopIndex',
  components: {
    TituloPadrao,
    ColunaGrade,
    Paginacao,
    Icone,
    Card,
    MensagemSemDados,
    PreferenciasColuna,
    BuscaGeral,
    CfopModal,
    PreviewPdf,
  },
  setup() {
    const {
      telaBase, preencherDadosRota, obterPermissoes, preencherEmpresasComEstrategiaPermissaoDados, filtrarPermissaoDadosUsuario,
      defineEmpresasSelecionadasComPermissao, telaOperacaoIncluir, telaOperacaoEditar, apresentarMensagemSucesso, apresentarMensagemAlerta, apresentarMensagemErro,
    } = useTelaBase();

    const { crudBase, exibirModal } = useCrudBase();

    const {
      gradeBase, salvarFiltrosBuscaAvancada, salvarOrdenacaoBuscaAvancada, salvarPersonalizacaoColunas, redefinirPersonalizacaoColunas,
      carregarPreferenciasGrade, preparaParametrosConsulta, salvarTodasPreferencias, preencheCodigosSelecionados,
    } = useGradeBase();

    const servicoCfop = new ServicoCfop();
    telaBase.empresasSelecionadas = [];
    gradeBase.ordenacaoSelecionada = [];

    gradeBase.colunasPadrao = [
      {
        title: 'CFOP', dataIndex: 'codigoCfop', key: 'CodigoCfop', position: 0, visible: true, ordering: true, width: 100, fixed: 'left', align: 'left', customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Descrição', dataIndex: 'descricao', key: 'DescricaoCfop', position: 1, visible: true, ordering: true, width: 800, fixed: 'left', align: 'left', ellipsis: true, customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Status', dataIndex: 'ativo', key: 'AtivoCfop', position: 2, visible: true, align: 'left', customRenderRow: ECustomRenderRow.TagAtivo,
      },
      {
        title: 'Ações', key: 'acoes', position: 3, visible: true, fixed: 'right', width: 100, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];

    gradeBase.colunasMobile = [
      {
        title: 'CFOP', dataIndex: '', key: 'Cfop', position: 0, visible: true, align: 'left',
      },
    ];

    const state = reactive({
      dados: [] as ICfop[],
      buscaRapida: '',
      exibirPersonalizarColunas: false,
      exibirBuscaAvancada: false,
      exibirPersonalizacaoTela: false,
      arquivosPdf: [] as IArquivoPdf[],
    });

    async function buscarDados() {
      state.dados = [];
      const parametrosConsulta = preparaParametrosConsulta(telaBase.empresasSelecionadas, gradeBase.paginacao.current, gradeBase.paginacao.pageSize, gradeBase.paginacao.total);
      parametrosConsulta.valorBuscaRapida = state.buscaRapida;
      telaBase.carregando = true;

      const listaCfopPaginado = await servicoCfop.buscaAvancada(parametrosConsulta, gradeBase.filtrosAplicados);
      state.dados = listaCfopPaginado.dados;
      gradeBase.paginacaoApi = listaCfopPaginado.metaData;
      telaBase.carregando = false;
    }

    async function imprimir(tipoArquivoRelatorio: ETipoArquivo, codigoRegistro?: number) {
      gradeBase.filtrosAplicados = [];
      const parametrosConsulta = preparaParametrosConsulta(telaBase.empresasSelecionadas, 1, 0, 0);
      let codigosSelecionados: number[] = [];
      if (codigoRegistro !== undefined && codigoRegistro > 0) {
        codigosSelecionados.push(codigoRegistro);
      } else {
        codigosSelecionados = gradeBase.codigosSelecionados;
      }

      telaBase.carregando = true;
      const retornoRelatorio = await servicoCfop.relatorioPadrao(tipoArquivoRelatorio, parametrosConsulta, gradeBase.filtrosAplicados, codigosSelecionados);
      telaBase.carregando = false;
      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        if (tipoArquivoRelatorio === ETipoArquivo.PDF) {
          state.arquivosPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
        } else {
          UtilitarioGeral.downloadArquivo(retornoRelatorio.link);
        }
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Erro) {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    async function carregarPreferencias() {
      telaBase.preferencias = await new ServicoSistema().obterPreferenciaRecurso(telaBase.identificadorRecurso, telaBase.empresasSelecionadas);
      if (telaBase.preferencias !== null) {
        carregarPreferenciasGrade(telaBase.preferencias);
      }
    }

    function verificarVisibilidadeConunaAcoes() {
      if (telaBase.permissaoDados.imprimir === false && storeSistema.state.configuracaoApp.tipoAmbiente === ETipoAmbiente.Plataforma) { gradeBase.visibilidadeColunaAcoes = false; }
      gradeBase.visibilidadeColunaAcoes = true;
    }
    onBeforeMount(async () => {
      preencherDadosRota();
      await obterPermissoes(ETipoPermissao.Dados);
      await preencherEmpresasComEstrategiaPermissaoDados(EPermissaoDados.Visualizar, false);
      await defineEmpresasSelecionadasComPermissao();
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuario(telaBase.empresasSelecionadas[0]);
      telaBase.propriedadesConsulta = await servicoCfop.obterPropriedadesConsulta();
      if (telaBase.propriedadesConsulta.length > 0) {
        gradeBase.buscaAvancada.filtros = telaBase.propriedadesConsulta.filter((item) => item.filtro === true);
        gradeBase.buscaAvancada.ordenacao = telaBase.propriedadesConsulta.filter((item) => item.ordenacao === true);
      }
      gradeBase.buscaAvancada.filtrosAdicionados = [];
      gradeBase.buscaAvancada.chaveFiltrosAdicionados = 0;
      await carregarPreferencias();
      verificarVisibilidadeConunaAcoes();
      await buscarDados();
    });

    function novoCfop() {
      exibirModal(telaOperacaoIncluir());
    }

    function editarCfop(codigo: number) {
      exibirModal(telaOperacaoEditar(codigo));
    }

    async function excluirCfop(codigo: number) {
      const retornoExclusao = await servicoCfop.excluir(codigo);
      if (retornoExclusao.status === EStatusRetornoRequisicao.Sucesso) {
        apresentarMensagemSucesso(retornoExclusao.mensagem);
        state.dados = state.dados.filter((cfop: ICfop) => cfop.codigo !== codigo);
      } else if (retornoExclusao.status === EStatusRetornoRequisicao.Alerta) {
        Modal.warning({
          title: 'Não foi possível concluir a exclusão!',
          content: retornoExclusao.mensagem,
        });
      }
    }

    async function confirmaExclusao(cfop: ICfop) {
      Modal.confirm({
        title: 'Você confirma a exclusão do CFOP:',
        content: `${cfop.codigoCfop} - ${cfop.descricao} ?`,
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: async () => { await excluirCfop(cfop.codigo); },
      });
    }

    async function sincronizarCfop(acao: EPermissaoDados, codigo: number) {
      if (acao === EPermissaoDados.Incluir || acao === EPermissaoDados.Alterar) {
        const parametrosConsulta: IParametrosConsulta = {} as IParametrosConsulta;

        if (!UtilitarioGeral.validaLista(telaBase.empresasSelecionadas)) {
          telaBase.empresasSelecionadas = storeSistema.getters.empresasUsuarioAutenticado();
        }

        parametrosConsulta.empresas = telaBase.empresasSelecionadas;
        parametrosConsulta.codigosSelecionados = [];

        parametrosConsulta.codigosSelecionados.push(codigo);
        const resultadoBusca = await servicoCfop.buscaAvancada(parametrosConsulta);
        if (UtilitarioGeral.validaLista(resultadoBusca.dados)) {
          if (acao === EPermissaoDados.Incluir) {
            state.dados.push(resultadoBusca.dados[0]);
          } else if (acao === EPermissaoDados.Alterar) {
            const index = state.dados.findIndex((c) => c.codigo === codigo);
            if (index >= 0) {
              state.dados[index] = resultadoBusca.dados[0];
            }
          }
        }
      }
    }

    function exibirApenasParaPainelAdministrativo(): boolean {
      return storeSistema.state.configuracaoApp.tipoAmbiente === ETipoAmbiente.Administracao;
    }

    function apresentarBuscaAvancada() {
      state.exibirPersonalizarColunas = false;
      state.exibirBuscaAvancada = !state.exibirBuscaAvancada;
    }

    function apresentarPersonalizarColuna() {
      state.exibirBuscaAvancada = false;
      state.exibirPersonalizarColunas = !state.exibirPersonalizarColunas;
    }

    function apresentarPersonalizacaoTela() {
      state.exibirPersonalizacaoTela = true;
    }

    async function aplicarFiltros() {
      gradeBase.paginacao.current = 1;
      await buscarDados();
    }

    function textoCodigosSelecionados(): string {
      if (gradeBase.codigosSelecionados.length === 1) { return '1 - CFOP selecionado'; }

      if (gradeBase.codigosSelecionados.length > 1) { return `${gradeBase.codigosSelecionados.length} - CFOPs selecionados`; }

      return '';
    }

    function obtemDataIndex(coluna: IColumn) {
      if (coluna.dataIndex !== undefined) {
        return coluna.dataIndex;
      }
      return '';
    }
    return {
      storeSistema,
      telaBase,
      gradeBase,
      crudBase,
      state,
      novoCfop,
      editarCfop,
      confirmaExclusao,
      excluirCfop,
      sincronizarCfop,
      apresentarBuscaAvancada,
      apresentarPersonalizarColuna,
      apresentarPersonalizacaoTela,
      aplicarFiltros,
      buscarDados,
      imprimir,
      ECustomRenderRow,
      EVinculoEmpresa,
      ETipoArquivo,
      salvarFiltrosBuscaAvancada,
      salvarOrdenacaoBuscaAvancada,
      salvarPersonalizacaoColunas,
      salvarTodasPreferencias,
      redefinirPersonalizacaoColunas,
      preencheCodigosSelecionados,
      textoCodigosSelecionados,
      obtemDataIndex,
      exibirApenasParaPainelAdministrativo,
    };
  },
});
